export function initLazyLoad() {
    $(function () {
        $("img.lazy").lazyload();
    });
}
